module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn', {
    class: ("button " + _vm.type),
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.$emit('click')
      }
    }
  }, [(_vm.type) ? _vm._t("default") : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bf515522","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/UiBtn.vue
// module id = 376
// module chunks = 2